import { useWindowScrollPositions } from '@aorg/hooks/common/useWindowScrollPositions';
import { createContext, useContext, useMemo, useRef } from 'react';

type Props = {
  scrollRef: React.MutableRefObject<null | HTMLDivElement>;
  scrollContainerId: string;
  scrollY: number;
  scrollToTop: () => void;
};

const Context = createContext<Props>(null!);

function useScrollViewContext() {
  return useContext(Context);
}

function AorgScrollView({ children, ...props }) {
  const scrollRef = useRef<null | HTMLDivElement>(null);
  const scrollContainerId = useMemo(
    () => Math.random().toString(36).substring(2, 9),
    []
  );
  const scroll = useWindowScrollPositions(scrollRef);
  const height = window.innerHeight;
  const scrollToTop = () => {
    if (scrollRef?.current)
      scrollRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Context.Provider
      value={{
        scrollRef,
        scrollContainerId,
        scrollY: scroll?.scrollY ?? 0,
        scrollToTop,
      }}
    >
      <div className="bg-black overflow-hidden " style={{ height }}>
        <div
          className="flex-1 w-full h-full overflow-auto"
          ref={scrollRef}
          id={scrollContainerId}
        >
          {children}
        </div>
      </div>
    </Context.Provider>
  );
}
export { useScrollViewContext };
export default AorgScrollView;
